import { useState, useEffect, useCallback } from "react";
import { ButtonCommon } from "../../../../Layout/styled";
import {
  FormTimer,
  LaunchFormContainer,
  LaunchFormTime,
  LaunchFormWrapper,
  LaunchStartForm,
  StartFormVisual,
} from "./styled";
import LaunchProjectName from "./Name";
import { GoogleFormProvider, useGoogleForm } from "react-google-forms-hooks";
import toast from "react-hot-toast";

const HTTPS_REGEX = /^https:\/\/.+/;
const DISCORD_REGEX = /^https:\/\/(discord\.gg|discord\.com\/invite)\/.+/;
const TWITTER_REGEX = /^https:\/\/(twitter\.com|x\.com)\/[a-zA-Z0-9_]{1,15}$/;
const TELEGRAM_REGEX = /^https:\/\/(t\.me|telegram\.me)\/.+/;

const LaunchForm = () => {
  const [start, setStart] = useState(false);
  const [errors, setErrors] = useState({});
  const [formValues, setFormValues] = useState<any>({});
  const [isReset, setIsReset] = useState(false)
  const formData: any = {
    title: "Test form",
    description: "Test form",
    action: "e/1FAIpQLSe5hQjEmngMdgIKCZws78KzlDBpylKq38uuMNmmcD9nmTqxoA",
    fvv: 1,
    pageHistory: 0,
    fbzx: "3237593378176625428",
    fields: [
      {
        id: "360457915",
        label: "Project's name",
        type: "SHORT_ANSWER",
        required: true,
        isLink: false,
        placeHolder: "Type your answer here",
      },
      {
        id: "2015867755",
        label: "Overview of Project",
        type: "SHORT_ANSWER",
        required: true,
        isLink: false,
        placeHolder: "Type your answer here",
      },
      {
        id: "2092296506",
        label: "Highlights of Project",
        type: "SHORT_ANSWER",
        required: true,
        isLink: false,
        placeHolder: "Type your answer here",
      },
      {
        id: "58542087",
        label: "Total raised before",
        type: "SHORT_ANSWER",
        required: true,
        isLink: false,
        placeHolder: "Type your answer here",
      },
      {
        id: "1435747441",
        label:
          "The round you're looking forwards to raising at Kibble: (Private, Public, Seed)",
        type: "SHORT_ANSWER",
        required: true,
        isLink: false,
        placeHolder: "Type your answer here",
      },
      {
        id: "530713946",
        label: "Website URL of your Project",
        type: "SHORT_ANSWER",
        required: true,
        isLink: true,
        placeHolder: "Https://",
        isHttps: true,
      },
      {
        id: "1010792971",
        label: "Official Twitter Profile",
        type: "SHORT_ANSWER",
        required: true,
        isLink: true,
        placeHolder: "Https://",
        isTwitter: true,
        isHttps: true,
      },
      {
        id: "1315995468",
        label: "Official Discord Channel",
        type: "SHORT_ANSWER",
        required: true,
        isLink: true,
        placeHolder: "Https://",
        isDiscord: true,
        isHttps: true,
      },
      {
        id: "1271013035",
        label: "Official Telegram Channel",
        type: "SHORT_ANSWER",
        required: true,
        isLink: true,
        placeHolder: "Https://",
        isTelegram: true,
        isHttps: true,
      },
      {
        id: "408170092",
        label: "Pick desk",
        type: "SHORT_ANSWER",
        required: true,
        isLink: true,
        placeHolder: "Https://",
        isHttps: true,
      },
      {
        id: "1849793390",
        label: "Token Symbol",
        type: "SHORT_ANSWER",
        required: true,
        isLink: false,
        placeHolder: "Type your answer here",
      },
      {
        id: "515349859",
        label: "Token IDO Price",
        type: "SHORT_ANSWER",
        required: true,
        isLink: false,
        placeHolder: "Type your answer here",
      },
      {
        id: "589850941",
        label: "Tokenomics",
        type: "SHORT_ANSWER",
        required: true,
        isLink: false,
        placeHolder: "Type your answer here",
      },
      {
        id: "1889093838",
        label: "Token Use Cases",
        type: "SHORT_ANSWER",
        required: true,
        isLink: false,
        placeHolder: "Type your answer here",
      },
      {
        id: "1490768381",
        label: "Blockchain",
        type: "SHORT_ANSWER",
        required: true,
        isLink: false,
        placeHolder: "Type your answer here",
      },
      {
        id: "1314104607",
        label:
          "Contact Information (Provide the main contact's Telegram handle)",
        type: "SHORT_ANSWER",
        required: true,
        isLink: false,
        placeHolder: "Type your answer here",
      },
    ],
    fieldsOrder: {
      "360457915": 0,
      "2015867755": 0,
      "2092296506": 0,
      "58542087": 0,
      "1435747441": 0,
      "530713946": 0,
      "1010792971": 0,
      "1315995468": 0,
      "1271013035": 0,
      "408170092": 0,
      "1849793390": 0,
      "515349859": 0,
      "589850941": 0,
      "1889093838": 0,
      "1490768381": 0,
      "1314104607": 0,
    },
  };

  const methods = useGoogleForm({ form: formData });

  // Validate all required fields
  const validateForm = () => {
    const newErrors: any = {};

    formData.fields.forEach((field: any) => {
      const value = formValues[field.id] || "";

      // Required field validation
      if (field.required && (!value || value.trim() === "")) {
        newErrors[field.id] = `Please fill in the "${field.label}" field.`;
        return;
      }

      // HTTPS validation
      if (field.isHttps && value && !HTTPS_REGEX.test(value)) {
        newErrors[field.id] = `The "${field.label}" must start with https://`;
        return;
      }

      // Discord link validation
      if (field.isDiscord && value && !DISCORD_REGEX.test(value)) {
        newErrors[
          field.id
        ] = `Please provide a valid Discord invite link (e.g., https://discord.gg/...)`;
        return;
      }

      // Twitter link validation
      if (field.isTwitter && value && !TWITTER_REGEX.test(value)) {
        newErrors[
          field.id
        ] = `Please provide a valid Twitter profile URL (e.g., https://twitter.com/username)`;
        return;
      }

      // Telegram link validation
      if (field.isTelegram && value && !TELEGRAM_REGEX.test(value)) {
        newErrors[
          field.id
        ] = `Please provide a valid Telegram link (e.g., https://t.me/username)`;
        return;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      const newErrors: any = {};

      formData.fields.forEach((field: any) => {
        const value = formValues[field.id] || "";

        if (field.required && value === "" && value !== undefined) {
          newErrors[field.id] = `Please fill in the "${field.label}" field.`;
          return;
        }

        if (field.isHttps && value && !HTTPS_REGEX.test(value)) {
          newErrors[field.id] = `The "${field.label}" must start with https://`;
          return;
        }

        if (field.isDiscord && value && !DISCORD_REGEX.test(value)) {
          newErrors[
            field.id
          ] = `Please provide a valid Discord invite link (e.g., https://discord.gg/...)`;
          return;
        }

        if (field.isTwitter && value && !TWITTER_REGEX.test(value)) {
          newErrors[
            field.id
          ] = `Please provide a valid Twitter profile URL (e.g., https://twitter.com/username)`;
          return;
        }

        if (field.isTelegram && value && !TELEGRAM_REGEX.test(value)) {
          newErrors[
            field.id
          ] = `Please provide a valid Telegram link (e.g., https://t.me/username)`;
          return;
        }
      });

      setErrors(newErrors);
    }, 200);

    return () => clearTimeout(timeout);
  }, [formValues]);

  const handleInputChange = useCallback((fieldId: any, value: any) => {
    setFormValues((prev: any) => ({
      ...prev,
      [fieldId]: value.trim(),
    }));
  }, []);

  const onSubmit = async () => {
    Object.entries(formValues).forEach(([fieldId, value]) => {
      methods.setValue(fieldId, value);
    });

    const isValid = validateForm();
    if (!isValid) {
      return;
    }

    try {
      await methods.submitToGoogleForms(formValues);
      toast.success("Form submitted successfully!");
      setErrors({});
      setFormValues({});
      setStart(false)
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Failed to submit form.");
    }
  };

  return (
    <GoogleFormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <LaunchFormContainer className={start ? "hide" : ""}>
          {!start ? (
            <LaunchFormWrapper>
              <div>
                <h2>Project Application Form</h2>
                <p>
                  Kibble is seeking ambitious Projects.
                  <br /> DeFi, AI, Infra, Gaming, Metaverses, NFTs.
                </p>
                <ButtonCommon
                  onClick={() => {
                    setStart(true);
                  }}
                >
                  Start Now
                </ButtonCommon>
                <LaunchFormTime>
                  <div>
                    <figure>
                      <img
                        src="/assets/images/form/timer_icon.svg"
                        alt="icon"
                      />
                    </figure>
                    <p>It might take about 2 minutes</p>
                  </div>
                  <FormTimer>
                    <span></span>
                  </FormTimer>
                </LaunchFormTime>
              </div>
            </LaunchFormWrapper>
          ) : (
            <LaunchStartForm>
              <StartFormVisual>
                <img
                  src="/assets/images/form/start_form_visual.png"
                  alt="visual"
                />
              </StartFormVisual>
              <LaunchProjectName
                formData={formData}
                errors={errors}
                formValues={formValues}
                handleInputChange={handleInputChange}
              />
            </LaunchStartForm>
          )}
        </LaunchFormContainer>
      </form>
    </GoogleFormProvider>
  );
};

export default LaunchForm;
